import React from 'react'
import createReactClass from 'create-react-class'
import logo from '../assets/images/connect-api-logo.png'
import {ENV_KEY, getSessionKey, TOKEN_KEY, USERNAME_KEY} from '../util/storage'
import './nav-bar.scss'
import RefreshTokenPanel from '../containers/refresh-token-panel-container'
import {getTokenExpireCountDown, copyToClipboard} from '../util/helpers'

export default createReactClass({
  getInitialState () {
    return {
      timer: getTokenExpireCountDown(),
    }
  },
  componentWillMount () {
    this.startTimer()
  },
  setTimerValue () {
    // to make sure that it displays the correct timer
    // we redetermine the value from the current time
    // instead of reducing the timer value by 1
    let timer = getTokenExpireCountDown()
    if (timer <= 0) {
      this.stopTimer()
    } else {
      this.setState({timer})
    }
  },
  startTimer () {
    // as asynchronous operations delay the callbacks
    // invocation, we set the interval time to be 30 secs
    // instead of 60secs.
    this.interval = setInterval(this.setTimerValue, 500 * 60)
  },
  stopTimer () {
    clearInterval(this.interval)
    this.props.logOut(this.props.history, true)
  },
  onSignOutClick () {
    this.props.logOut(this.props.history)
  },
  onCopyTokenToClipboard () {
    let success = copyToClipboard(getSessionKey(TOKEN_KEY), document)
    if (success) {
      this.props.setInfoObject({message: 'Token copied to clipboard', error: false})
    } else {
      this.props.setInfoObject({message: 'Token not copied to clipboard', error: true})
    }
  },
  showAnalysisPage () {
    this.props.history.push('/analysis')
  },
  render () {
    return (
      <div className='nav-bar-ctr'>
        <nav className="navbar navbar-default no-border-radius custom-navbar">
          <div className="nav-bar-top-grid"></div>
          <div className="container-fluid">
            <div className="logo-grid pull-left">
              <img alt="Brand" className="header-logo" src={logo} />
            </div>
            <div className="info-grid pull-right">
              <ul className="csc-nav">
                <li className="dropdown">
                  <a className="dropdown-toggle flex-display no-gutter" data-toggle="dropdown" role="button" aria-haspopup="true" aria-expanded="false">
                    <div className='icon-grid'>
                      <span className="fa fa-user-o fa-2"/>
                    </div>
                    <div className='user-info-grid'>
                      <div className='details-row'>{getSessionKey(USERNAME_KEY)}</div>
                      <div className="environment details-row">{getSessionKey(ENV_KEY)}</div>
                      <div className='details-row'><span className="token-expiry-text">Token Expires in </span><span className="token-expiry-time">{this.state.timer}</span> Mins</div>
                    </div>
                  </a>
                  <ul className="dropdown-menu">
                    <RefreshTokenPanel/>
                    <li><a onClick={this.onCopyTokenToClipboard}>Copy token to clipboard</a></li>
                    { getSessionKey(USERNAME_KEY) && getSessionKey(USERNAME_KEY).includes('@creditsafe')
                      ? <li onClick={this.showAnalysisPage}><a>Usage Logs</a></li> : null }
                    {this.props.languageAccess.length > 0 ? <li onClick={() => this.props.history.push('/monitoringTranslations')}><a>Monitoring Translations</a></li>
                      : null}
                    <li className='dotted-line'></li>
                    <li><a onClick={this.onSignOutClick}>Sign Out</a></li>
                  </ul>
                </li>
              </ul>
            </div>
          </div>
        </nav>
      </div>
    )
  },
  componentDidMount () {
    if (this.state.timer <= 0) {
      this.stopTimer()
    }
  },

  componentWillReceiveProps (nextProps) {
    if (nextProps.isTokenRefreshed) {
      this.setState({
        timer: getTokenExpireCountDown(),
      })
    }
  },
})



// WEBPACK FOOTER //
// ./src/components/nav-bar.js